import moment from "moment"
import { cpfMask, numberMask, phoneMask } from "../../core/utils/validateFields"
import { DatePicker } from "../DatePicker"
import { Input, InputTextArea, SelectInput } from "../Form"
import { RadioButton } from "../RadioButton"

export const getInputTypeGeneralRegistration = (field, editedChatFields, handleChangeChatField, translated) => {
  switch (field) {
    case "document" || "cpf":
      return (
        <Input
          name={field}
          onChange={(e) => handleChangeChatField(e)}
          hasFocus={false}
          value={cpfMask(editedChatFields[field]) || ""}
          placeholder="000.000.000-00"
          max={14}
        />
      )
    case "whatsapp" || "phone" || "tel":
      return (
        <Input
          name={field}
          onChange={(e) => handleChangeChatField(e, field)}
          hasFocus={false}
          value={phoneMask(`${editedChatFields[field]}`.replace("+55", "")) || ""}
          placeholder="(00) 00000-0000"
          min={14}
          max={15}
        />
      )
    case "birthday":
      return (
        <DatePicker
          onChange={(e) => handleChangeChatField(field, e)}
          value={editedChatFields[field] && editedChatFields[field].includes("-") ? moment(editedChatFields[field], "YYYY-MM-DD").format("DD/MM/YYYY") : editedChatFields[field] || ""}
          placeholder="DD/MM/YYYY"
        />
      )
    default:
      return (
        <Input
          name={field}
          onChange={(e) => handleChangeChatField(e, field)}
          hasFocus={false}
          value={editedChatFields[field] || ""}
          placeholder={translated}
        />
      )
  }
}

export const getInputTypeIndicators = (
  formQuestionId,
  field,
  formId,
  onChangeQuestionsInfo,
  values,
) => {
  const commonProps = {
    handleChange: (value) =>
      onChangeQuestionsInfo(field.type, value, field?.answer?.id, { formId, formQuestionId }),
    options: Array.isArray(field?.options)
      ? [...new Set(field?.options)].map(({ title }) => ({ value: title, label: title }))
      : [],
    value: values[formQuestionId] || field?.answer?.value || field?.answer,
    placeholder: "Selecione",
  }

  switch (field.type) {
    case "radio":
      return <div className="edit-field-input radio">
        {commonProps.options.map(({ label, value }) => {
          return <RadioButton
            checked={(values[formQuestionId] || field?.answer?.value) === value}
            classPrymary="edit-row-radio"
            className="radio-indicators"
            text={label}
            onChange={(e) => onChangeQuestionsInfo(field.type, { label, value }, field?.answer?.id, { formId, formQuestionId })}
          />
        })}
      </div>
    case "select":
    case "checkbox":
    case "users":
      return (
        <div className="edit-field-input select">
          <SelectInput
            key={field.id}
            isSearchable={true}
            isClearable={true}
            {...commonProps}
            value={
              field.type === "checkbox"
                ? values[formQuestionId]?.includes("|")
                  ? values[formQuestionId]
                      .split("|")
                      .map((item) => (item.value ? item : { value: item, label: item }))
                  : [{ value: values[formQuestionId], label: values[formQuestionId] }]
                : commonProps.value
            }
            isMulti={field.type === "checkbox"}
          />
        </div>
      )
    case "textarea":
      return (
        <div className="edit-field-input text-area">
          <InputTextArea
            type="textarea"
            className="inputArea"
            onChange={(e) =>
              onChangeQuestionsInfo(field.type, e.target.value, field?.answer?.id, {
                formId,
                formQuestionId,
              })
            }
            hasFocus={false}
            value={values[formQuestionId] || field?.answer?.value}
            placeholder={field?.answer?.value}
          />
        </div>
      )
    case "date":
      return (
        <Input
          type="date"
          onChange={(e) =>
            onChangeQuestionsInfo(field.type, e.target.value, field?.answer?.id, {
              formId,
              formQuestionId,
            })
          }
          hasFocus={false}
          value={values[formQuestionId] || field?.answer?.value}
          placeholder={field?.answer?.value}
        />
      )
    case "datetime":
      return (
        <Input
          type="datetime-local"
          onChange={(e) =>
            onChangeQuestionsInfo(field.type, e.target.value, field?.answer?.id, {
              formId,
              formQuestionId,
            })
          }
          hasFocus={false}
          value={values[formQuestionId] || field?.answer?.value}
          placeholder={field?.answer?.value}
          min="14"
          max="15"
        />
      )
    case "number":
      return (
        <Input
          type="number"
          onChange={(e) =>
            onChangeQuestionsInfo(field.type, numberMask(e.target?.value), field?.answer?.id, {
              formId,
              formQuestionId,
            })
          }
          hasFocus={false}
          defaultValue={field?.answer?.value}
          value={values[formQuestionId] || field?.answer?.value}
          placeholder={field?.answer?.value}
        />
      )
    case "email":
      return (
        <Input
          type="email"
          onChange={(e) =>
            onChangeQuestionsInfo(field.type, e.target.value, field?.answer?.id, {
              formId,
              formQuestionId,
            })
          }
          hasFocus={false}
          value={values[formQuestionId] || field?.answer?.value}
          placeholder={field?.answer?.value}
        />
      )
    default:
      return (
        <div className="edit-field-input text">
          <Input
            onChange={(e) =>
              onChangeQuestionsInfo(field.type, e?.target?.value, field?.answer?.id, {
                formId,
                formQuestionId,
              })
            }
            hasFocus={false}
            value={values[formQuestionId] || field?.answer?.value}
            placeholder={"Selecione"}
          />
        </div>
      )
  }
}
